<template>
  <div class="labeled-pet-sex-selector">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <PetSexSelector
      ref="petSexSelector"
      :id="inputId"
      :value="value"
      :placeholder="placeholder"
      :is-disabled="isDisabled"
      :empty-state-text="emptyStateText"
      :error-messages="errorMessages"
      v-on="$listeners"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import PetSexSelector from '../pet-sex-selector';
import { RandomId } from '@/shared/lib/random';
import { InputLabel } from '@/shared/ui/form';

const { generateRandomId } = RandomId();

export default {
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    label: {
      type: String,
      default: 'Стать',
    },
    placeholder: {
      type: String,
      default: 'Оберіть стать',
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inputId: `pet-sex-selector-${this.generateRandomId()}`,
    };
  },
  components: { InputLabel, PetSexSelector },
  computed: {
    getPetSexSelect() {
      return this.$refs.petSexSelector;
    },
  },
  methods: {
    generateRandomId,
  },
};
</script>